<template>
  <div
    class="etichetta"
    v-bind:style="{ 'background-color' : (stato.color || 'grey') }"
  >{{ stato.label || 'ciao'}}</div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";

export default {
  name: "crudTableMagazzinoStato",
  props: ["trItem"],
  directives: {},
  data() {
    return {
      //VARIABILI AMBIENTE
    };
  },
  computed: {
    stato() {
      let obj = {};
      if (this.trItem.stock !== undefined) {
        let quantità = this.trItem.stock.qty || 0;
        switch (true) {
          case quantità === 0:
            obj.color = "red";
            obj.label = "Non Disponibile";
            break;
          case quantità > 0 && quantità < 3:
            obj.color = "orange";
            obj.label = "In esaurimento";
            break;
          case quantità >= 3:
            obj.color = "#01c776";
            obj.label = "Disponibile";
            break;
          default:
          // code block
        }
      }
      return obj;
    }
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.nome {
  font-weight: 500;
  text-transform: capitalize;
}

.etichetta {
  width: 90%;
  text-align: center;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;

  color: white;
  font-weight: bold;
  text-transform: capitalize;
  opacity: 0.7;
}
</style>
